/**
 * Round 16 O1 -- "Download the signed group register".
 *
 * The pack verified and was correct, and no control offered it: not on
 * either groups page, not on the examiner's seat. It was reached only
 * through the admin API. One control, three places, the endpoint as the
 * only difference.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { currentAuthToken } from "shared/api/client";

export const GROUP_PACK_PATH = "/v1/admin/exports/ibs-group-register-pack.zip";
export const EXAMINER_GROUP_PACK_PATH = "/v1/examiner/ibs-group-register-pack.zip";

async function download(path: string): Promise<void> {
  const token = currentAuthToken();
  const response = await fetch(path, {
    headers: {
      Accept: "application/zip",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) {
    let detail = "";
    try {
      detail = String(
        (JSON.parse(await response.text()) as { detail?: string }).detail ?? "",
      );
    } catch {
      detail = "";
    }
    throw new Error(detail || `HTTP ${response.status}`);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "marsad-ibs-group-register-pack.zip";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

export function GroupRegisterDownload({ path = GROUP_PACK_PATH }: { path?: string }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <div data-testid="group-register-download" className="space-y-1">
      <button
        type="button"
        data-testid="group-register-download-button"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          download(path)
            .catch((e: Error) => setError(e.message))
            .finally(() => setBusy(false));
        }}
        className="rounded border border-brand-brass/40 bg-brand-brass/5 px-3 py-1.5 text-sm font-medium text-brand-brassDark hover:bg-brand-brass/10 disabled:opacity-50"
      >
        {busy ? t("groupRegister.downloading") : t("groupRegister.download")}
      </button>
      <p className="text-xs text-slate-500">{t("groupRegister.body")}</p>
      {error && (
        <p data-testid="group-register-download-error" className="text-sm text-rag-red">
          {error}
        </p>
      )}
    </div>
  );
}
